import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden pt-[60px] md:pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              海角免费视频 · 畅享高清观影
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
              海角网 · 免费在线视频平台
            </h1>

            <p className="mt-3 md:mt-4 text-base md:text-lg text-foreground-600 leading-relaxed">
              海角网是新一代免费在线观看平台，致力于为每一位用户提供无需付费的高清视频体验。
            </p>
            <p className="mt-2 text-sm md:text-base text-foreground-500 leading-relaxed">
              覆盖悬疑剧场、都市情感、动漫追番、纪录片、经典港片重制等十二大内容品类，原创独播与经典修复同步上线，每日更新海量免费资源。海角免费视频让你随时随地打开就能看，无广告干扰、无会员门槛，真正做到海角网免费看的承诺。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-5 md:mt-6">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-primary-600">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-compass-3-line"></i>
                探索专题合集
              </a>
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-300 text-foreground-700 rounded-md text-sm font-medium hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-line"></i>
                热门推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20home%20entertainment%20scene%20with%20a%20large%20modern%20screen%20displaying%20colorful%20film%20strips%20and%20play%20buttons%2C%20cozy%20living%20room%20atmosphere%20with%20warm%20ambient%20lighting%2C%20soft%20textures%2C%20cinematic%20color%20grading%20with%20amber%20and%20teal%20tones%2C%20clean%20minimal%20composition%2C%20professional%20photography%20quality%2C%20warm%20inviting%20aesthetic&width=800&height=600&seq=hero-main-01&orientation=landscape"
                alt="海角网免费在线视频平台 - 海量高清内容畅享"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}